var exports = {
  "q": "skeleton__loz8Zx",
  "x": "counterLabel__ygB5VX",
};

module.exports = exports;
